// ── Exception form — edit/view a single covenant/field-exam exception ──
import { useState } from "react";
import { fmtDate } from "../../../shared/format";
import { Btn, Field, Modal } from "../../../shared/ui";
import { useApp } from "../../../shared/appContext";

export const ExceptionForm = ({ initial, onClose, onSaved }) => {
    const { api, delRec, role, setConfirm } = useApp();
        const [issue, setIssue]           = useState(initial.issue || "");
        const [pmresponse, setPmresponse] = useState(initial.pmresponse || "");
        const [busy, setBusy]             = useState(false);
        const [err, setErr]               = useState(null);
        const canEdit = role.canEdit;
      
        const save = async () => {
          setBusy(true); setErr(null);
          try {
            await api.post("saveCovenantException", { id: initial.id, covenantcalendarid: initial.covenantcalendarid, issue, pmresponse });
            onSaved && onSaved(); onClose();
          } catch (e) { setErr(e.message || "Save failed"); setBusy(false); }
        };
        const del = () => setConfirm({
          msg:"Delete this exception?",
          onConfirm:()=>delRec("CovenantExceptions", initial.id, "Deleted covenant exception", ()=>{ onSaved && onSaved(); onClose(); })
        });
      
        const RO = ({ label, value }) => <Field label={label}><div style={{ padding:"7px 10px", fontSize:13, borderRadius:4, border:"1px solid #ddd", background:"#f5f5f5", color:"#555", minHeight:18 }}>{value||"—"}</div></Field>;
        const box = { padding:"7px 10px", fontSize:13, borderRadius:4, border:"1px solid #ddd", background:"#f5f5f5", minHeight:18, whiteSpace:"normal" };
        const TA  = { width:"100%", boxSizing:"border-box", padding:"7px 10px", fontSize:13, borderRadius:4, border:"1px solid #999", background:"#fff", color:"#1a1a1a", fontFamily:"inherit" };
      
        return <Modal title="Field Exam Exception" onClose={onClose}>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 16px" }}>
            <RO label="Company Name" value={initial.companyname} />
            <RO label="Covenant Name" value={initial.covenantname} />
            <RO label="Test Date" value={initial.testdate ? fmtDate(initial.testdate) : "—"} />
            <RO label="Due Date" value={initial.duedate ? fmtDate(initial.duedate) : "—"} />
          </div>
          <div style={{ marginTop:12 }}><Field label="Issue">
            {canEdit ? <textarea rows={3} style={TA} value={issue} onChange={e=>setIssue(e.target.value)} /> : <div style={box}>{issue||"—"}</div>}
          </Field></div>
          <div style={{ marginTop:12 }}><Field label="PM Response">
            {canEdit ? <textarea rows={3} style={TA} value={pmresponse} onChange={e=>setPmresponse(e.target.value)} /> : <div style={box}>{pmresponse||"—"}</div>}
          </Field></div>
          {err && <div style={{ color:"#993C1D", fontSize:12, marginTop:8 }}>{err}</div>}
          <div style={{ display:"flex", gap:8, justifyContent:"flex-end", marginTop:16 }}>
            {role.canDelete && <Btn variant="danger" onClick={del}>Delete</Btn>}
            <Btn onClick={onClose}>{canEdit?"Cancel":"Close"}</Btn>
            {canEdit && <Btn variant="primary" disabled={busy} onClick={save}>{busy?"Saving...":"Save"}</Btn>}
          </div>
        </Modal>;
      };
